import { Model, attr } from 'redux-orm';
import {
  createAction,
  createDeleteConst,
  createLoadConst,
  createRequestConst,
} from '../util';

const RECORD_ID = 'current';

/**
 * Status load outcome for the enrolled Login Failures modal.
 * `credential === null` is true both before load and after a soft-miss 404,
 * so the modal needs this explicit flag (not just a null credential).
 * idle → loading (via loading reducer on LOAD.ACTION) → found | notFound
 */
export const STATUS_OUTCOME_IDLE = 'idle';
export const STATUS_OUTCOME_FOUND = 'found';
export const STATUS_OUTCOME_NOT_FOUND = 'notFound';

export default class PalIfpCredential extends Model {
  static get modelName() {
    return 'PalIfpCredential';
  }

  static reducer({ type, data }, PalIfpCredential) {
    switch (type) {
      case LOAD.ACTION: {
        const previous = PalIfpCredential.withId(RECORD_ID);
        const lastReset = previous?.ref?.lastReset;
        PalIfpCredential.delete();
        PalIfpCredential.create({
          id: RECORD_ID,
          statusOutcome: STATUS_OUTCOME_IDLE,
          ...(lastReset ? { lastReset } : {}),
        });
        break;
      }

      case LOAD.SUCCESS: {
        const previous = PalIfpCredential.withId(RECORD_ID);
        const lastReset = previous?.ref?.lastReset;
        PalIfpCredential.delete();
        if (data?.response) {
          PalIfpCredential.create({
            id: RECORD_ID,
            ...data.response,
            statusOutcome: STATUS_OUTCOME_FOUND,
            ...(lastReset ? { lastReset } : {}),
          });
        } else {
          PalIfpCredential.create({
            id: RECORD_ID,
            statusOutcome: STATUS_OUTCOME_NOT_FOUND,
            ...(lastReset ? { lastReset } : {}),
          });
        }
        break;
      }

      case DISABLE.SUCCESS:
      case ENABLE.SUCCESS: {
        const previous = PalIfpCredential.withId(RECORD_ID);
        const lastReset = previous?.ref?.lastReset;
        PalIfpCredential.delete();
        if (data?.response) {
          PalIfpCredential.create({
            id: RECORD_ID,
            ...data.response,
            statusOutcome: STATUS_OUTCOME_FOUND,
            ...(lastReset ? { lastReset } : {}),
          });
        }
        break;
      }

      case RESET.SUCCESS: {
        const previous = PalIfpCredential.withId(RECORD_ID);
        const lastReset = data?.response ?? null;
        if (previous) {
          previous.update({ lastReset });
        } else if (lastReset) {
          PalIfpCredential.create({ id: RECORD_ID, lastReset });
        }
        break;
      }

      case LOAD.FAILURE:
      case CLEAR.ACTION:
        PalIfpCredential.delete();
        break;

      default:
        break;
    }
  }

  static get fields() {
    return {
      id: attr(),
      fspId: attr(),
      contacts: attr(),
      enabled: attr(),
      userStatus: attr(),
      givenName: attr(),
      familyName: attr(),
      lastError: attr(),
      lastReset: attr(),
      statusOutcome: attr(),
    };
  }
}

const name = PalIfpCredential.modelName;

export const LOAD = createLoadConst(name);
export const STATUS = LOAD;
export const DISABLE = createRequestConst(`${name}_disable`);
export const ENABLE = createRequestConst(`${name}_enable`);
export const RESET = createRequestConst(`${name}_reset`);
export const CLEAR = createDeleteConst(`${name}_clear`);

export const loadStatus = createAction(LOAD);
export const load = loadStatus;
export const disable = createAction(DISABLE);
export const enable = createAction(ENABLE);
export const reset = createAction(RESET);
export const resetRequest = reset;
export const clear = createAction(CLEAR);
